import { ProjectDocumentsTable } from "Components/General/AddFilesInput/ProjectDocumentsTable";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import * as React from "react";
import { XktModelInfo } from "../Stores/XKTViewerStore";

interface AttachXKTFilesProps extends ModalComponentProps {
  onAddFiles: (props: XktModelInfo) => Promise<void>;
  initialFolderId: number;
  fromXKTViewer?: boolean;
}

export const AttachXKTFiles = ({ hideModal, onAddFiles, initialFolderId, fromXKTViewer }: AttachXKTFilesProps) => {
  const handleAddAttachments = React.useCallback(
    async (entities: API_FileDataEntity[]) => {
      if (entities?.length) {
        for (const entity of entities) {
          await onAddFiles({ fileId: entity.id, fileName: entity.name });
        }
      }
      hideModal();
    },
    [hideModal]
  );
  return (
    <ProjectDocumentsTable
      handleAddAttachments={handleAddAttachments}
      hideSearch={true}
      onExit={hideModal}
      startingFolderId={initialFolderId}
      minimumAccessLevel="READONLY"
      allowedFileTypes={["xkt", "ifc", "ifczip", "laz", "las", "cityjson", "glb", "gltf", "stl", "ply"]}
      fromXKTViewer={fromXKTViewer}
    />
  );
};
